module.exports = __webpack_public_path__ + "media/images/credits_logo_2x_large-f0586b38bb7910ecc3bc1efbdd4d64cd.png";